import { actionTypes } from "./actions";

const initialState = {
  data: [],
  validationRuleEdit: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_VALIDATION_RULES:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_VALIDATION_RULE_BY_ID:
      return {
        ...state,
        validationRuleEdit: {
          ...payload
        }
      };

    case actionTypes.EDIT_VALIDATION_RULE_FORM_CHANGE:
      return {
        ...state,
        validationRuleEdit: {
          ...state.validationRuleEdit,
          [payload.name]: payload.value,
        },
      };

    default:
      return {
        ...state,
      };
  }
};
